import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as styles from "./UploadRequest.module.scss";
import ExcelUploader from "./HandleFileSelect";
import { createAccessRequestApi } from "../../../services/RequestAccess/RequestAccess";
import { triggerToast } from "../../../utils/toast";
import { useNavigate } from "react-router-dom";
import { removeDuplicates } from "../../../utils/commonUtil";
import Button from "../../../Components/Common/CprimeButton";

const getCreateAccessRequestPayload = (res: any) => {
  const output = {
    bulk_user_featurePermissions: [],
  } as any;

  res?.forEach((row: any) => {
    // res?.data?.validation?.rowResults?.forEach((row: any) => {
    const data = row;
    if (
      !data?.permissionIds ||
      data?.permissionIds?.length === 0 ||
      !data?.user_email_id ||
      !row?.isValid
    )
      return;

    const findIndex = output.bulk_user_featurePermissions.findIndex(
      (record: any) => record?.target_user?.mail === data?.user_email_id,
    );

    const featurePermissionIds = [] as any;
    data.permissionIds.forEach((permissionId: any) => {
      featurePermissionIds.push({
        featureId: data?.featureId,
        permissionId,
        justification: data?.justification || "", // As per your required output
      });
    });

    if (findIndex < 0)
      output.bulk_user_featurePermissions?.push({
        target_user: {
          displayName: data?.displayName,
          mail: data?.user_email_id,
          user_workday_id: data?.workday_id,
        },
        featurePermissionIds,
      });
    else {
      output.bulk_user_featurePermissions[findIndex] = {
        ...output.bulk_user_featurePermissions[findIndex],
        featurePermissionIds: removeDuplicates([
          ...(output?.bulk_user_featurePermissions[findIndex]
            ?.featurePermissionIds || []),
          ...(featurePermissionIds || []),
        ]),
      };
    }
  });
  return output;
};

interface UploadRequestProps {
  open: boolean;
  onClose: () => void;
}
type Step = "upload" | "processing" | "done" | "preview";

function UploadRequestDialog({ open, onClose }: UploadRequestProps) {
  const [isSubmitDisable, setIsSubmitDisable] = useState(true);
  const [step, setStep] = useState<Step>("upload");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const scssClass = styles as any;
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!selectedRows?.length) return;
    setLoading(true);
    try {
      const requestPayload = getCreateAccessRequestPayload(selectedRows);
      const res = await createAccessRequestApi(requestPayload);
      if (res?.response?.data.error) {
        triggerToast(res?.message || "File uploaded failed", "error");
      } else {
        triggerToast(res?.message || "File uploaded successfully", "success");
        navigate("/request-status");
      }
    } catch (err) {
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const checkFileUploadStatus = () => {};

  useEffect(() => {
    checkFileUploadStatus();
  }, []);

  return (
    <Dialog
      open={open}
      // onClose={() => onClose()}
      fullWidth
      maxWidth={`md`}
      sx={{
        "& .MuiDialogContent-root": {
          paddingBottom: "0.5rem !important",
          paddingTop: "0px !important",
          paddingLeft: "1.5rem !important",
          paddingRight: "1.5rem !important",
        },
      }}
    >
      <div
        style={{
          maxWidth: "945px",
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 400,
            fontSize: "1.5rem",
            lineHeight: "2rem",
            color: "#000000",
          }}
        >
          {step === "preview" ? "Select Request(s)" : "Upload File"}
          <IconButton onClick={() => onClose()} data-testid="closemodal">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <div style={{ maxHeight: "calc(100vh - 200px)", width: "100%" }}>
            <ExcelUploader
              setIsSubmitEnabled={() => setIsSubmitDisable(false)}
              step={step}
              setStep={setStep}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
            <div className={scssClass.divider} />
            <div className={scssClass.responsiveCard}>
              <div className={scssClass.modalFooterButtonSection}>
                <div style={{ fontSize: "12px", color: "#58595B" }}>
                  {step === "preview"
                    ? "Reviewing data from File"
                    : `${step === "done" ? 1 : 0}/1 files uploaded`}
                </div>
                <div className={scssClass.buttonSection}>
                  <Button
                    variant="tertiary"
                    sx={{ marginLeft: "4px", marginRight: "4px" }}
                    onClick={() => onClose()}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    disabled={
                      step === "preview"
                        ? selectedRows?.length === 0
                        : isSubmitDisable
                    }
                    sx={{ marginLeft: "4px", marginRight: "4px" }}
                    onClick={() => {
                      if (step === "done") setStep("preview");
                      else if (step === "preview") handleSubmit();
                    }}
                    loading={loading}
                  >
                    {step === "preview" ? "Submit" : "Preview Import"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </div>
    </Dialog>
  );
}

export default UploadRequestDialog;
